// hooks/usePusherChannel.js
import { useEffect } from "react";
import Pusher from "pusher-js";

let pusherInstance = null;

function getPusherInstance() {
  if (!pusherInstance) {
    Pusher.logToConsole = false;
    pusherInstance = new Pusher("f1b255b7c74088ee23a6", {
      cluster: "mt1",
    });
  }
  return pusherInstance;
}

export function usePusherChannel(channelName, eventName, callback) {
  useEffect(() => {
    const pusher = getPusherInstance();
    const channel = pusher.subscribe(channelName);

    channel.bind(eventName, callback);

    return () => {
      channel.unbind(eventName, callback);
      pusher.unsubscribe(channelName);
    };
  }, [channelName, eventName, callback]);
}
